<template>
  <div style="margin-top: 200px;display: flex;">
    <span>已为你新打开个人主页页面</span>
  </div>
</template>

<script>
export default {

  name: 'manage',
  props: {
    Kid: {
      type: String,
      default: ''
    },
    isHttp: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  methods: {

  },
  watch: {
    isHttp: {
      handler (val) {
        if (this.isHttp === '2' && !this.isRoles) {
          console.log(this.isHttp)

          let routeData = this.$router.resolve({
            path: 'Detail',
            query: { kId: this.Kid }
          })
          window.open(routeData.href, '_blank')
        }
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss">
.basics {
  padding-bottom: 20px;
  height: 250px;
  margin-top: 50px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  background: #fff;
  .avatat {
    text-align: center;
    width: 150px;
    .el-button {
      margin-top: 10px;
    }
  }
  .basic_info {
    width: 35%;
    height: 100%;
    .info_inp {
      height: 80%;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      color: #838383;
      font-size: 12px;
      margin-left: 20%;
      justify-content: space-between;
      div {
        word-break: break-all;
        .el-input {
          width: 60%;
          .el-input__inner {
            height: 20px;
            line-height: 20px;
          }
        }
      }
    }
    .el-button {
      margin-top: 10px;
      float: right;
      margin-right: 20px;
    }
  }
  .basic_resume {
    border-left: 1px solid #000000;
    width: 50%;
    padding-left: 2%;
    .resume_input {
      margin-top: 1%;
    }
    .el-button {
      margin-top: 2%;
      float: right;
    }
  }
}
.menus {
  background: #fff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/center/menu/detail.vue